// import log from 'loglevel';
import pushGTMEvent from '../../util/helper/pushGTMEvent';

const configContents = ({
  state: {
    langStrings,
    currentCMDetails,
    newCmDetails,
  },
}) => {
  return [
    {
      isTitle: true,
      hasSuccessMark: true,
      description: langStrings
        ? langStrings.successScreen.pageTitle
        : 'Success',
      id: 'adsk-page-title',
    },
    {
      BGColor: '#f7fcfe',
      BGPadding: '20px 20px 20px',
      description: langStrings
        ? langStrings.cm.successScreen.responseText4
            .replace('<contract-number>', currentCMDetails.contractNumber)
        : 'Contract number <contract-number> has a new contract manager:',
      style: {
        color: '#333',
        fontWeight: 400,
        marginbottom: '20px',
      },
      id:'adsk-success-disclaimer'
    },
    {
      BGColor: '#f7fcfe',
      BGPadding: '0px 20px 20px',
      description: `${newCmDetails.firstName} ${newCmDetails.lastName}<br/>${newCmDetails.email}`,
      style: {
        color: '#333',
        fontWeight: 700,
      },
    },
    {
      BGColor: '#f7fcfe',
      BGPadding: '0px 20px 20px',
      description: langStrings
        ? langStrings.successScreen.updateDisclaimer
        : 'Please allow a few hours for the change to appear in your account.',
      style: {
        color: '#333',
        marginbottom: '20px',
        fontStyle: 'italic',
        fontSize: '12px',
        fontWeight: 500,
      },
    },
    {
      description: langStrings
        ? langStrings.cm.successScreen.cmWillReceiveEmail
        : 'The new contract manager will get an email with more instructions.',
      paragraphStyle: { margin: '30px 0 30px' },
      id:'adsk-success-email-message'
    },
  ];
};

const configFooter = ({
  state: {
    langStrings,
    hasExtension
  },
  dispatch,
}) => ({
  hasQuestion: true,
  hasExtension,
  hideBackButton: true,
  nextButtonContent: langStrings ? langStrings.buttons.restartButton : 'RESTART',
  handleNext: () => {
    dispatch({ type: 'RESTART_WIDGET' })
    window.location.reload(true);
  },
  handleExtension: () => dispatch({ type: 'TOGGLE_QUESTION_EXTENSION' }),
  handleAgentLoad: () => {
    pushGTMEvent('ChatWithAgent');
    dispatch({ type: 'AGENT_LOADED' });
  },
  handleAgentAvailable: (flag) => dispatch({ type: 'AGENT_AVALIABLE', payload: { isAgentAvailable: flag } }),
  handleChatInitialized: () => dispatch({ type: 'AGENT_INITIALIZED' }),
  handleChatStarted: () => dispatch({ type: 'GO_TO_AGENT_AVAILABLE_PAGE' }),
  handleSupportAnalytics: () => pushGTMEvent('ContactSupport'),
  handleAgentAnalytics: () => pushGTMEvent('ChatWithAgent'),
  handleCaseAnalytics: () => pushGTMEvent('CreateCase'),
  handleNextButtonId: 'adsktm-cm-next-button',
  handleAgentButtonId: 'adsktm-agent-button',
  handleCaseButtonId: 'adsktm-case-button',
  handleQuestionButtonId: 'adsktm-have-question-button',
});

export default {
  configContents,
  configFooter,
};
